import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import { useParams } from "react-router-dom";
import {
  Col,
  Row,
  Card,
  Image,
  Table,
  Typography,
  Skeleton,
  Button,
} from "antd";

import useTransactionInfo from "./useTransactionInfo";
import VeridocTransactionInfoDataSource from "./VeridocTransactionInfoDataSource";
import VerifaceTransactionInfoDataSource from "./VerifaceTransactionInfoDataSource";
import VeriliveTransactionInfoDataSource from "./VeriliveTransactionInfoDataSource";

function CaptionImage({ src, caption }) {
  const [visible, setVisible] = useState(false);

  return (
    <div style={{ marginBottom: "24px" }}>
      <Typography.Text
        style={{
          display: "inline-block",
          marginBottom: "8px",
        }}
      >
        {caption}
      </Typography.Text>
      <Image
        preview={{
          visible: false,
        }}
        width={280}
        src={src}
        onClick={() => setVisible(true)}
        style={{
          borderRadius: "8px",
        }}
        className="session-card__photo"
      />
      <div
        style={{
          display: "none",
        }}
      >
        <Image.PreviewGroup
          preview={{
            visible,
            onVisibleChange: (value) => setVisible(value),
          }}
        >
          <Image src={src} />
        </Image.PreviewGroup>
      </div>
    </div>
  );
}

function VeridocInfoFragment({ service_name, transaction_id }) {
  const { isLoading, transactionInfo } = useTransactionInfo(
    service_name,
    transaction_id
  );
  const dataSource = VeridocTransactionInfoDataSource(transactionInfo);
  const { columns, rows } = dataSource.asTableView();
  const { face_picture, sign_picture } = dataSource.asImageView();

  if (dataSource.isEmpty()) {
    return (
      <Card className="session__card session-card">
        <Typography.Text>No content!</Typography.Text>
      </Card>
    );
  }

  return (
    <Skeleton loading={isLoading}>
      <Card className="session__card session-card">
        <Row gutter={32}>
          <Col flex="auto">
            <Table
              columns={columns}
              dataSource={rows}
              pagination={false}
              showHeader={false}
            />
          </Col>
          <Col flex="246px">
            <CaptionImage caption={face_picture.label} src={face_picture.src} />
            <CaptionImage caption={sign_picture.label} src={sign_picture.src} />
          </Col>
        </Row>
      </Card>
    </Skeleton>
  );
}

function VerifaceInfoFragment({ service_name, transaction_id }) {
  const { isLoading, transactionInfo } = useTransactionInfo(
    service_name,
    transaction_id
  );
  const dataSource = VerifaceTransactionInfoDataSource(transactionInfo);
  const { columns, rows } = dataSource.asTableView();

  if (dataSource.isEmpty()) {
    return (
      <Card className="session__card session-card">
        <Typography.Text>No content!</Typography.Text>
      </Card>
    );
  }

  return (
    <Skeleton loading={isLoading}>
      <Card className="session__card session-card">
        <Row gutter={32}>
          <Col flex="auto">
            <Table
              columns={columns}
              dataSource={rows}
              pagination={false}
              showHeader={false}
            />
          </Col>
        </Row>
      </Card>
    </Skeleton>
  );
}

function VeriliveInfoFragment({ service_name, transaction_id }) {
  const { isLoading, transactionInfo } = useTransactionInfo(
    service_name,
    transaction_id
  );
  const dataSource = VeriliveTransactionInfoDataSource(transactionInfo);
  const { columns, rows } = dataSource.asTableView();

  if (dataSource.isEmpty()) {
    return (
      <Card className="session__card session-card">
        <Typography.Text>No content!</Typography.Text>
      </Card>
    );
  }

  return (
    <Skeleton loading={isLoading}>
      <Card className="session__card session-card">
        <Row gutter={32}>
          <Col flex="auto">
            <Table
              columns={columns}
              dataSource={rows}
              pagination={false}
              showHeader={false}
            />
          </Col>
        </Row>
      </Card>
    </Skeleton>
  );
}

export default function TransactionInfoPage(props) {
  // const { service_name, transaction_id } = useParams();

  // if (service_name === "veridoc") {
  //     return (
  //         <VeridocInfoFragment
  //             service_name={service_name}
  //             transaction_id={transaction_id}
  //         />
  //     )
  // }

  // if (service_name === "veriface") {
  //     return (
  //         <VerifaceInfoFragment
  //             service_name={service_name}
  //             transaction_id={transaction_id}
  //         />
  //     )
  // }

  // if (service_name === "verilive") {
  //     return (
  //         <VeriliveInfoFragment
  //             service_name={service_name}
  //             transaction_id={transaction_id}
  //         />
  //     )
  // }

  return (
    <>
      <Row
        gutter={16}
        style={{
          backgroundColor: "white",
          padding: "8px",
          borderRadius: "16px",
          height: "fit-content",
        }}
      >
        <Col span={12} className="card-media">
          <Typography.Title level={4}>Session ID</Typography.Title>
          <Typography.Text>1234567890</Typography.Text>
          <div className="card-media-preview"></div>
          <div className="card-media-btns">
            <Button>Download Video of Check</Button>
            <Button>Send Report</Button>
          </div>
        </Col>
        <Col span={12} className="card-table" style={{ rowGap: "8px" }}>
          <Row gutter={16}>
            <Col span={12}>
              <Typography.Title level={4}>Status</Typography.Title>
              <Typography.Text>Approved</Typography.Text>
              <Card className="table-status"></Card>
            </Col>
            <Col span={12}>
              <Typography.Title level={4}>Type of Check</Typography.Title>
              <Typography.Text>Auto</Typography.Text>
              <Card className="table-check"></Card>
            </Col>
          </Row>
          <Card className="card-table-lower"></Card>
        </Col>
      </Row>
    </>
  );
}
